module.exports = __webpack_public_path__ + "img/awin.a8872b03.png";